import React from 'react';
import PdfDeck from '../PdfDeck';

function GarhmukhteshwarPhase2() {
  return <PdfDeck file='/machines-pdfs/mushroom_farm_garh_phase2.pdf' />;
}

export default GarhmukhteshwarPhase2;
